import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Button, Card, Col, DatePicker, Form, Input, Row, Table } from 'antd';

import moment from 'moment';
import util from '@util/index';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';

const { Description } = DescriptionList;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delFiles: [],
    };
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;

    const params = {
      ...this.props.form.getFieldsValue(),
    };

    this.props.form.validateFields((err, values) => {
      if (!err) {
        params.uuid = data.uuid;
        delete params.crName;
        params.moveOutDate = params.moveOutDate.format('YYYY-MM-DD');
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.businessUuid}/info`}>
            {record.isTransfer ? <span style={{ color: 'yellow' }}>转</span> : null}
            {text}
          </Link>
        ),
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.deadline ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.deadline / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.price ? '收费注册' : '免费注册'}</span>;
        },
      },
      {
        title: '合同金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '推荐人员',
        dataIndex: 'recommend',
        key: 'recommend',
        render: (text, record) => {
          return (
            <span>
              {text}
              <span style={{ marginLeft: '10px' }}>{record.recommendTel}</span>
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'isCurrent',
        key: 'isCurrent',
        render: (text, record) => {
          return <span>{text ? '当前关联' : '历史关联'}</span>;
        },
      },
    ];
  };

  render() {
    const dataItem = this.props.data;
    const { isSubmitting } = this.props;
    const { getFieldDecorator } = this.props.form;
    const {
      addresses = [],
      settleds = [],
      // files = [],
      currentSettled = {},
    } = dataItem;

    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
    let day = 0;
    if (currentSettled.deadline) {
      day = Math.floor((Date.now() - currentSettled.deadline) / 86400000);
    }
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {/* {dataItem.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={this.props.handleDelete}
            >
              删除
            </Button>
          ) : null} */}
        </div>

        <Card title="地址注册详情">
          <DescriptionList size="large" col={3}>
            <Description term="孵化器">{dataItem.incubator}</Description>
            <Description term="公司名称">{dataItem.custom}</Description>
            <Description term="项目名称">{dataItem.projectName}</Description>
            <Description term="开始时间">
              {currentSettled.beginDate
                ? moment.unix(currentSettled.beginDate / 1000).format('YYYY-MM-DD')
                : ''}
            </Description>
            <Description term="到期时间">
              {currentSettled.deadline
                ? moment.unix(currentSettled.deadline / 1000).format('YYYY-MM-DD')
                : ''}
              {day && day > 0 ? (
                <span style={{ color: 'red', marginLeft: '10px' }}>（逾期{day}天）</span>
              ) : (
                ''
              )}
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="注册地址">
              <div>
                {addresses.map(item => {
                  return <div key={item.url}>{item.name}</div>;
                })}
              </div>
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="关联基础孵化合同" />
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={settleds}
            />
          </DescriptionList>
        </Card>

        <Card title="申请信息">
          <Row>
            <Col span={10}>
              <FormItem label="迁出时间" {...ItemLayout}>
                {dataItem.moveOutDate
                  ? getFieldDecorator('moveOutDate', {
                      initialValue: moment(dataItem.moveOutDate),
                      rules: [{ required: true, message: '请选择迁出时间' }],
                    })(<DatePicker />)
                  : getFieldDecorator('moveOutDate', {
                      rules: [{ required: true, message: '请选择迁出时间' }],
                    })(<DatePicker />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="相关附件" {...ItemLayout}>
                {getFieldDecorator('moveOutFiles', {
                  rules: [{ required: true, message: '请上传附件' }],
                  initialValue: dataItem.moveOutFiles || [],
                })(
                  <UploadFile
                    type="ghost"
                    fileList={dataItem.moveOutFiles}
                    onRemove={this.fileRemove}
                    isPreview
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="申请备注" {...ItemLayout2}>
                {getFieldDecorator('moveOutRemark', {
                  initialValue: dataItem.moveOutRemark,
                  rules: [{ required: true, message: '请填写申请备注' }],
                })(
                  <Input.TextArea
                    placeholder="备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="申请人" {...ItemLayout}>
                {getFieldDecorator('crName', {
                  initialValue: dataItem.createUserName,
                })(<span>{this.props.accountInfo.userName}</span>)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(BaseForm));



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/FormBase.js